import React, { Component } from 'react'
import styles from './DownloadAppForm.module.scss';
import classNames from 'classnames/bind';

import {Header, SubHeader, ContactUsText, AwairLogo, AppStoreButton, GooglePlayButton} from '../../atoms';
import { downloadAppFormContentsEn } from '../../../assets/contents/download-app-form';
import AppImage from '../../../assets/images/app-img.jpg';

const cx = classNames.bind(styles);

class DownloadAppForm extends Component {
  render() {
    const {
      header,
      headerDescription,
      downloadDescription,
      contactUsDescription
    } = downloadAppFormContentsEn;
    return (
      <div>
        <AwairLogo />
        <div className={cx('DownloadAppForm')}>
          <div className={cx('DownloadAppForm__header-wrapper')}>
            <Header text={header} />
            <SubHeader text={headerDescription}/>
          </div>
          <img className={cx('DownloadAppForm__app-image')} src={AppImage} alt="App" />
          <p className={cx('DownloadAppForm__download-description')}>{downloadDescription}</p>
          <div className={cx('DownloadAppForm__download-store')}>
            <AppStoreButton />
            <GooglePlayButton />
          </div>
          
        </div>
        <ContactUsText className={cx('DownloadAppForm__contact-us')} text={contactUsDescription} mailLink='hello@getawair.com'/>
      </div>
    )
  }
}

export default DownloadAppForm;